// @flow

import LumeraPersistGate from '@components/LumeraPersistGate';
import DYORServerSyncGate from '@components/DYORServerSyncGate';
import DyorSynchronizers from '@components/synchronizers/DyorSynchronizers';

import type { Node } from 'react';

type TProps = {
  children: Node,
  fallback?: Node
};

const DyorDataWrapper = function DyorDataWrapper({
  children,
  fallback
}: TProps) {
  return (
    <LumeraPersistGate fallback={fallback}>
      <DyorSynchronizers />
      <DYORServerSyncGate fallback={fallback}>{children}</DYORServerSyncGate>
    </LumeraPersistGate>
  );
};

export default DyorDataWrapper;
